import { useEffect, useState } from "react";
import Button from "../button";
import { DialogActions } from "../dialog";
import TextInput from "../text-input";
import { Checkbox, Flex } from "antd";

type Props = {
  onChange?: (width?: number, height?: number) => void;
  currentWidth?: number;
  currentHeight?: number;
};

export default function CellResizeDropdown({
  onChange,
  currentWidth,
  currentHeight,
}: Props) {
  const [width, setWidth] = useState<number | undefined>(currentWidth);
  const [height, setHeight] = useState<number | undefined>(currentHeight);
  const [autoHeight, setAutoHeight] = useState(currentHeight === undefined);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    setIsDisabled((width ?? 0) <= 0);
  }, [width]);

  return (
    <>
      <TextInput
        label="عرض"
        onChange={(e) => setWidth(parseInt(e))}
        value={`${width}`}
        data-test-id="cell-resize-modal-width"
        type="number"
        labelSpan={4.3}
      />
      <Flex align="baseline">
        <TextInput
          label="طول"
          onChange={(e) => setHeight(parseInt(e))}
          value={`${height}`}
          data-test-id="cell-resize-modal-height"
          type="number"
          disabled={autoHeight}
        />
        <Flex className="w-100" align="center" justify="center" gap={12}>
          <label htmlFor="auto-height-checkbox">اتوماتیک</label>
          <Checkbox
            id="auto-height-checkbox"
            checked={autoHeight}
            onChange={(e) => {
              setAutoHeight(e.target.checked);
              setHeight(e.target.checked ? undefined : currentHeight);
            }}
          />
        </Flex>
      </Flex>
      <div className="text-danger fs-x-small mt-7">
        * ممکن است طول سلول تحت تاثیر محتوای داخل آن بیشتر به نظر بیاید
      </div>
      <DialogActions data-test-id="table-model-confirm-insert">
        <Button disabled={isDisabled} onClick={() => onChange?.(width, height)}>
          اعمال
        </Button>
      </DialogActions>
    </>
  );
}
